import { sendAdminNotification } from './emailJsPortal';

function escape(s) {
  if (s == null || s === '') return '';
  return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function buildProductEmail(product, profile, action) {
  const companyName = profile?.company_name || 'Unknown';
  const productName = product.product_name || 'Unnamed';
  const subject = `[MarketVendr] Product ${action}: ${productName} (${companyName})`;
  const message = [
    `A client has ${action} a product in the Vendr portal.`,
    '',
    `Company: ${escape(companyName)}`,
    `Product: ${escape(productName)}`,
    `SKU: ${escape(product.sku_number || '—')}`,
    `Status: ${escape(product.status || 'draft')}`,
  ].join('\n');
  const clientSubject = action === 'added' ? 'Product submitted – MarketVendr' : 'Product updated – MarketVendr';
  const verb = action === 'added' ? 'has been submitted successfully' : 'has been updated';
  const clientMessage = [
    'Hello,',
    '',
    `This is to confirm that your product "${escape(productName)}" ${verb} in the MarketVendr portal.`,
    'We will review it and get in touch if we need anything further.',
    '',
    'Thanks,',
    'The MarketVendr team',
  ].join('\n');
  return { subject, message, clientSubject, clientMessage };
}

export async function notifySetupComplete(profile) {
  if (!profile?.id) return;
  const companyName = profile.company_name || 'Unknown';
  const subject = `[MarketVendr] Company setup complete: ${companyName}`;
  const message = [
    'A client has completed company setup in the Vendr portal.',
    '',
    `Company: ${escape(profile.company_name || '—')}`,
    `Brand / supplier: ${escape(profile.brand_supplier_name || '—')}`,
    `Contact: ${escape(profile.first_name || '')} ${escape(profile.last_name || '')} – ${escape(profile.email || '—')}`,
  ].join('\n');
  await sendAdminNotification({ subject, message });
}

export async function notifyProductAdded(product, profile) {
  if (!product?.id) return;
  const { subject, message, clientSubject, clientMessage } = buildProductEmail(product, profile, 'added');
  await sendAdminNotification({
    subject,
    message,
    clientEmail: profile?.email,
    clientSubject,
    clientMessage,
  });
}

export async function notifyProductEdited(product, profile) {
  if (!product?.id) return;
  const { subject, message, clientSubject, clientMessage } = buildProductEmail(product, profile, 'edited');
  try {
    await sendAdminNotification({
      subject,
      message,
      clientEmail: profile?.email,
      clientSubject,
      clientMessage,
    });
  } catch (e) {
    console.warn('[notifyClientPortal] notifyProductEdited error:', e?.message);
  }
}
